﻿﻿﻿<h2>Controller configuration for {{defaults.controllertype.Description}}</h2>
<div style="display:flow-root">
    <div style="float:left; width:40vw">
        <h5>Remote Action settings in this tab apply <b>globally to all tenants for the selected controller type.</b></h5>
    </div>
    <div style="text-align:right; float:right">
        <h5>**A PBI must be created and assigned to anyone from DevOps Team for deploying new changes.**</h5>
    </div>
</div>
<allowedactionscontrollertype-list [list]="mergedList" [isEditableMethod]="isEditable" (onReload)="onReload($event)"></allowedactionscontrollertype-list>